var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSynchronize = function SvgSynchronize(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 8.73438,
    x2: 86,
    y2: 166.095566,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(12.156863%,86.666667%,58.431375%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 60.46875,
    y1: 8.73438,
    x2: 60.46875,
    y2: 166.095566,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(12.156863%,86.666667%,58.431375%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 111.53125,
    y1: 8.73438,
    x2: 111.53125,
    y2: 166.095566,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(12.156863%,86.666667%,58.431375%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 73.90625,
    x2: 86,
    y2: 98.195869,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(49.803922%,92.941177%,76.862746%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8895746"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 25 33.59375 C 29.738281 33.59375 33.59375 29.738281 33.59375 25 C 33.59375 20.261719 29.738281 16.40625 25 16.40625 C 20.261719 16.40625 16.40625 20.261719 16.40625 25 C 16.40625 29.738281 20.261719 33.59375 25 33.59375 Z M 25 17.96875 C 28.878906 17.96875 32.03125 21.121094 32.03125 25 C 32.03125 28.878906 28.878906 32.03125 25 32.03125 C 21.121094 32.03125 17.96875 28.878906 17.96875 25 C 17.96875 21.121094 21.121094 17.96875 25 17.96875 Z M 25 17.96875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 9.226562 29.46875 C 11.121094 28.867188 12.5 27.089844 12.5 25 C 12.5 22.90625 11.121094 21.132812 9.226562 20.53125 C 11.140625 13.71875 17.140625 8.957031 24.21875 8.625 L 24.21875 10.972656 C 24.21875 11.519531 24.503906 12.011719 24.988281 12.289062 C 25.230469 12.429688 25.5 12.5 25.769531 12.5 C 26.042969 12.5 26.316406 12.429688 26.558594 12.289062 L 30.894531 9.769531 C 31.605469 9.355469 32.03125 8.625 32.03125 7.8125 C 32.03125 7 31.605469 6.269531 30.894531 5.855469 L 26.558594 3.339844 C 26.074219 3.054688 25.472656 3.054688 24.988281 3.335938 C 24.503906 3.613281 24.21875 4.105469 24.21875 4.652344 L 24.21875 7.0625 C 16.359375 7.398438 9.703125 12.71875 7.664062 20.320312 C 5.148438 20.398438 3.125 22.464844 3.125 25 C 3.125 27.535156 5.148438 29.601562 7.664062 29.679688 C 8.753906 33.722656 11.210938 37.269531 14.664062 39.699219 L 15.5625 38.421875 C 12.464844 36.242188 10.246094 33.078125 9.226562 29.46875 Z M 30.109375 7.207031 C 30.433594 7.394531 30.46875 7.695312 30.46875 7.8125 C 30.46875 7.929688 30.433594 8.230469 30.109375 8.417969 L 25.78125 10.925781 L 25.773438 4.6875 Z M 4.6875 25 C 4.6875 23.277344 6.089844 21.875 7.8125 21.875 C 9.535156 21.875 10.9375 23.277344 10.9375 25 C 10.9375 26.722656 9.535156 28.125 7.8125 28.125 C 6.089844 28.125 4.6875 26.722656 4.6875 25 Z M 4.6875 25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 46.875 25 C 46.875 22.464844 44.851562 20.398438 42.335938 20.320312 C 41.246094 16.277344 38.789062 12.730469 35.335938 10.300781 L 34.4375 11.578125 C 37.535156 13.757812 39.753906 16.921875 40.773438 20.53125 C 38.878906 21.132812 37.5 22.910156 37.5 25 C 37.5 27.09375 38.878906 28.867188 40.777344 29.46875 C 38.859375 36.28125 32.859375 41.042969 25.78125 41.375 L 25.78125 39.027344 C 25.78125 38.480469 25.496094 37.988281 25.011719 37.710938 C 24.527344 37.429688 23.921875 37.429688 23.441406 37.714844 L 19.105469 40.230469 C 18.394531 40.644531 17.96875 41.375 17.96875 42.1875 C 17.96875 43 18.394531 43.730469 19.105469 44.144531 L 23.441406 46.660156 C 23.683594 46.804688 23.957031 46.875 24.230469 46.875 C 24.5 46.875 24.769531 46.804688 25.011719 46.664062 C 25.496094 46.386719 25.78125 45.894531 25.78125 45.347656 L 25.78125 42.9375 C 33.640625 42.601562 40.296875 37.28125 42.335938 29.679688 C 44.851562 29.601562 46.875 27.535156 46.875 25 Z M 24.21875 45.308594 L 19.890625 42.792969 C 19.566406 42.605469 19.53125 42.304688 19.53125 42.1875 C 19.53125 42.070312 19.566406 41.769531 19.890625 41.582031 L 24.21875 39.027344 Z M 42.1875 28.125 C 40.464844 28.125 39.0625 26.722656 39.0625 25 C 39.0625 23.277344 40.464844 21.875 42.1875 21.875 C 43.910156 21.875 45.3125 23.277344 45.3125 25 C 45.3125 26.722656 43.910156 28.125 42.1875 28.125 Z M 42.1875 28.125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 25 21.875 C 23.273438 21.875 21.875 23.273438 21.875 25 C 21.875 26.726562 23.273438 28.125 25 28.125 C 26.726562 28.125 28.125 26.726562 28.125 25 C 28.125 23.273438 26.726562 21.875 25 21.875 Z M 25 21.875 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSynchronize, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/synchronize.de1ea224.svg";
export { ForwardRef as ReactComponent };